import { makeSimpleGetRequest, makeSimplePostRequest } from "lib/axios";
import { ORDERBOOK_URL } from "services/constants";
import { Valuation } from "services/valuation/types";

export const getOrCreateValuation = async (
  assetId: number,
): Promise<Valuation> => {
  return await makeSimplePostRequest<Valuation>(
    `${ORDERBOOK_URL}/valuations/`,
    JSON.stringify({
      asset_id: assetId,
    }),
    [200, 201],
  );
};

export const getValuationResult = (
  valuationId: number | string,
): Promise<Valuation> =>
  makeSimpleGetRequest(
    `${ORDERBOOK_URL}/valuations/${valuationId}/?include[]=results.*`,
  );
